import { makeCRUDSlice } from 'redux/crudCreator';
import { companyBrandsActions, MODEL_NAME } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, companyBrandsActions);

export default slice.reducer;
